import React, { HTMLProps } from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { SortIcon } from '../../../components/ui/icons';
import { IColumns } from '../../../common/types/firmwareTypes';

const IndeterminateCheckbox = ({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) => {
  const ref = React.useRef<HTMLInputElement>(null!);

  React.useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
    return () => {};
  }, [ref, indeterminate]);

  return (
    <>
      <input
        type='checkbox'
        ref={ref}
        className={className + ' cursor-pointer'}
        {...rest}
      />
    </>
  );
};

const useUpdateIotAgentVersionColumns = ({ onRowSelectionChange }) => {
  const columns: ColumnDef<IColumns, string>[] = React.useMemo(
    () => [
      {
        accessorFn: (row) => `${row?.name}`,
        accessorKey: 'name',
        header: (row) => (
          <div className='table-heading'>
            Name{' '}
            <span>
              <SortIcon />
            </span>
          </div>
        ),
        cell: ({ row, getValue }) => (
          <div>
            <>
              <IndeterminateCheckbox
                {...{
                  checked: row.getIsSelected(),
                  indeterminate: row.getIsSomeSelected(),
                  onChange: onRowSelectionChange(row),
                }}
              />{' '}
              {getValue()}
            </>
          </div>
        ),
        enableColumnFilter: false,
        footer: (props) => props.column.id,
      },
      {
        accessorFn: (row) => `${row?.version}`,
        accessorKey: 'version',
        header: (row) => (
          <div className='table-heading'>
            Version{' '}
            <span>
              <SortIcon />
            </span>
          </div>
        ),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
        cell: (row) => <div className='table-cell'>{row.getValue()}</div>,
      },
      {
        accessorFn: (row) => `${row?.timestamp}`,
        accessorKey: 'timestamp',
        header: (row) => (
          <div className='table-heading'>
            UpdatedAt{' '}
            <span>
              <SortIcon />
            </span>
          </div>
        ),
        footer: (props) => props.column.id,
        enableColumnFilter: false,
        cell: (row) => (
          <div className='table-cell'>
            {new Date(row.getValue()).toLocaleString()}
          </div>
        ),
      },
    ],
    [onRowSelectionChange]
  );

  return {
    columns,
  };
};

export default useUpdateIotAgentVersionColumns;
